import React from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import WorkSpaceCard from "../Components/WorkSpaceCard";

const Workspace = () => {
  return (
    <DashboardLayout>
      <section className="bg-white pl-6 py-4 gap-y-5 w-full flex flex-col items-start">
        <Breadcrumbs links={[{ name: "workspace", link: "dsads" }]} />
        <h1 className="text-xl font-semibold">My AI Workspace</h1>
      </section>
      <section className="bg-[#f9fafb] h-screen w-full flex items-start justify-center pt-6">
        <div className="w-[90%]">
          <div className="flex items-stretch flex-wrap gap-6">
            <WorkSpaceCard
              heading="My AI Projects"
              text="AI-Assisted Project Analyser and Recommender System. Post AI Project. Match AI Team."
              bgcolor="#BCF0DA"
            />
            <WorkSpaceCard
              heading="My Tasks"
              text="Assign Tasks to AI team. Track Completion Period."
              bgcolor="#AFECEF"
            />
            <WorkSpaceCard
              heading="AI Collab - UPGRADE"
              text="Individual or Team. You Will Be Matched With A Resource In The Area Where You Seek Collaboration Or Assistance."
              bgcolor="#CDDBFE"
            />
            <WorkSpaceCard
              heading="Individual Profile"
              text="Build your Personal Brand in AI."
              bgcolor="#FAD1E8"
            />
            <WorkSpaceCard
              heading="Team Profile"
              text="Team AI profiles. Orchestrating & Managing Projects."
              bgcolor="#FBD5D5"
            />
            <WorkSpaceCard
              heading="Ask Generative AI - UPGRADE"
              text="Find the Right AI Team for the AI Project. Query the People AI Ecosystem in Natural Language."
              bgcolor="#FCD9BD"
            />
          </div>
        </div>
      </section>
    </DashboardLayout>
  );
};

export default Workspace;
